import { firstValueFrom } from 'rxjs';
import { FilterGroup } from '@custom-components/general/table-filter-bar';
import { CompanyService } from '@core/services';

/** The "partner" typeahead pill shared by the devices, locations and services list pages. */
export function partnerFilterGroup(
  companyService: CompanyService,
  label: string,
  placeholder: string,
): FilterGroup {
  return {
    key: 'partner',
    label,
    type: 'typeahead',
    selection: 'single',
    placeholder,
    search: query =>
      firstValueFrom(
        companyService.getListCompaniesFilter({ limit: 10, offset: 0, partnerName: query }),
      ).then(res => (res.partners ?? []).map(p => ({ id: p.partnerOid, label: p.partnerName }))),
    resolve: id =>
      firstValueFrom(companyService.getCompanyDetail(id)).then(p => ({ id, label: p.partnerName })),
  };
}
